import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartButton = () => {
  const { totalItems, setIsCartOpen } = useCart();

  return (
    <button
      onClick={() => setIsCartOpen(true)}
      className="relative p-2 hover:bg-slate-800/50 rounded-lg transition-colors group"
      data-testid="cart-button"
      aria-label={`Carrinho com ${totalItems} itens`}
    >
      <ShoppingCart className="w-6 h-6 text-slate-300 group-hover:text-yellow-500 transition-colors" />
      
      <AnimatePresence>
        {totalItems > 0 && (
          <motion.span
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            className="absolute -top-1 -right-1 w-5 h-5 bg-yellow-500 text-slate-900 text-xs font-bold rounded-full flex items-center justify-center"
            data-testid="cart-badge"
          >
            {totalItems > 99 ? '99+' : totalItems}
          </motion.span>
        )}
      </AnimatePresence>
    </button>
  );
};

export default CartButton;
